import angular from 'angular';
import { MovimentacoesAdmissoesFormController } from './movimentacoes-admissoes-form.controller';

export class MovimentacoesAdmissoesFormComponent implements angular.IComponentOptions {
    static selector = 'meurhMovimentacoesAdmissoesForm';
    static controller = MovimentacoesAdmissoesFormController;
    static template = require('!!html-loader!./movimentacoes-admissoes-form.html');
    static bindings = {
        model: '=',
        formRef: '=?',
        admissionDate: '<?',
        disabled: '<?',
        onValidityChange: '&?'
    };
}
